<template>
    <div>
        <!-- 表单搜索部分 -->
        <el-card class="box-card" shadow="hover">
            <div slot="header" class="clearfix">
                <span>奖励发放查询</span>
            </div>
            <el-form :inline="true" :model="formInline" class="demo-form-inline">
                <el-form-item>
                    <el-select
                        size
                        v-model="formInline.realStatus"
                        clearable
                        placeholder="请选择奖励类型"
                    >
                        <el-option label="激活奖励" value="0"></el-option>
                        <el-option label="交易量达标奖励" value="1"></el-option>
                        <el-option label="交易量阶梯奖励" value="2"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select
                        size
                        v-model="formInline.realStatus"
                        clearable
                        placeholder="请选择终端类型"
                    >
                        <el-option label="终端类型1" value="0"></el-option>
                        <el-option label="终端类型2" value="1"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="formInline.firstName" placeholder="请输入终端SN"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="formInline.firstId" placeholder="请输入一级代理名称"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="formInline.realName" placeholder="请输入一级代理账号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-input size clearable v-model="formInline.userName" placeholder="请输入订单号"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button
                        size="medium"
                        type="primary"
                        icon="el-icon-search"
                        style="font-size: 12px;"
                        @click="onSubmit(formInline)"
                    >查询</el-button>
                </el-form-item>
            </el-form>
        </el-card>
        <!-- 表格部分 -->
        <el-card class="box-card" style="margin-top: 20px;" shadow="hover">
            <!-- <div style="margin-bottom: 20px;">
                <el-button size="small" type="primary" icon="el-icon-plus" @click>占位</el-button>
            </div> -->
            <el-table
                :data="awardingTable.list"
                size="mini"
                border
                style="width: 100%"
                v-loading="loading"
            >
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed
                    prop="id"
                    label="ID"
                    min-width="80"
                ></el-table-column>
                <!-- 终端类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="brandName"
                    label="终端类型"
                    min-width="120"
                ></el-table-column>
                <!-- 终端SN -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="machinePrice"
                    label="终端SN"
                    min-width="120"
                ></el-table-column>
                <!-- 一级代理名称 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rateMethod"
                    label="一级代理名称"
                    min-width="120"
                ></el-table-column>
                <!-- 一级代理账号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rateMethod"
                    label="一级代理账号"
                    min-width="120"
                ></el-table-column>
                <!-- 奖励类型 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rateMethod"
                    label="奖励类型"
                    min-width="120"
                ></el-table-column>
                <!-- 奖励金额 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rateMethod"
                    label="奖励金额"
                    min-width="120"
                ></el-table-column>
                <!-- 达成时间 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rateMethod"
                    label="达成时间"
                    min-width="120"
                ></el-table-column>
                <!-- 我的分润 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rateMethod"
                    label="我的分润"
                    min-width="120"
                ></el-table-column>
                <!-- 订单号 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    prop="rateMethod"
                    label="订单号"
                    min-width="120"
                ></el-table-column>
                <!-- 操作 -->
                <el-table-column
                    header-align="center"
                    align="center"
                    fixed="right"
                    label="操作"
                    min-width="150"
                >
                    <template slot-scope="scope">
                        <el-button
                            @click="handleInfo(scope.$index,scope.row)"
                            type="text"
                            size="small"
                        >详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 分页部分 -->
            <paginations
                :currentPage="page.currentPage"
                :pageSize="page.pageSize"
                :total="page.total"
                @watchCurrent="getCurrent"
                @watchPageSize="getPageSize"
            ></paginations>
        </el-card>
    </div>
</template>

<script>
import paginations from '../../../components/pagination/paginations';
export default {
    name: "DM_awardingList",
    data() {
        return {
            formInline: {
                firstName: '', //一级代理姓名
                firstId: '',    //一级代理账号
                realName: '',   //用户真实姓名
                userName: '',   //用户账号
                inviteCode: '', //用户邀请码
                realStatus: '', //实名认证状态
                referralsName: '', // 推荐人真实姓名
                referralsPhone: '', //推荐人手机号
                createTime: '', //用户注册时间
                loginTime: '',  //最近登录时间
                address: '' //地区

            },
            awardingTable: {
                list: [],
            },
            page: {
                currentPage: 1, //当前页码
                pageSize: 10, //条数
                total: 100  //总数
            },
            loading: true
        }
    },
    mounted() {
        this.getTableList(this.page.currentPage, this.page.pageSize);
    },
    components: {
        paginations
    },
    methods: {
        onSubmit() {
            // 表单提交
        },
        //
        handleInfo() { //详情
        },
        //分页
        getCurrent(page) {
            // 获取当前页修改的值
            this.page.currentPage = page;
            this.loading = true;
            this.getTableList(this.page.currentPage, this.page.pageSize);
        },
        getPageSize(limit) {
            // 获取条数发生改变的值
            this.page.pageSize = limit;
            this.loading = true;
            this.getTableList(this.page.currentPage, limit);
        },
        getTableList(page, limit) {
            this.$api.post(this.$port.brandList, { page, limit }, res => {
                let data = res.data;
                this.page.total = data.count; //总数
                this.awardingTable.list = data.list;
                //渲染结束后取消加载
                this.loading = false;
            })
        }
    }
};
</script>

<style lang="scss" scope>
.el-input__inner {
    font-size: 12px;
}
.el-form-item {
    margin-bottom: 5px;
}
</style>
